import './RadioGroup.css';
import '../input/Input.css';
import { useTranslation } from "react-i18next";

export interface RadioItem {
    label: string;
    value: string;
}

interface RadioGroupProps {
    name: string;
    items: RadioItem[];
    value?: string;
    onChange: (value: string) => void;
    title?: string;
    isRequired?: boolean;
}

export const RadioGroup = ({ name, items, value, onChange, title, isRequired }: RadioGroupProps) => {
    const {t} = useTranslation();
    return (
        <div className="radio-group">
            {title && (
                <div className="common-input-title-container">
                    <span className="common-input-title">{title}</span>
                    {isRequired && <span className="common-input-required">{t("required")}</span>}
                </div>
            )}
            <ul className="radio-group-list">
                {items.map((item) => (
                    <li key={item.value} className="radio-item">
                        <input
                            type="radio"
                            id={`${name}_${item.value}`}
                            name={name}
                            value={item.value}
                            checked={value === item.value}
                            onChange={() => onChange(item.value)}
                            className="blind"
                        />
                        <label
                            htmlFor={`${name}_${item.value}`}
                            className={value === item.value ? 'selected' : ''}
                        >
                            {item.label}
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    );
};
